import React, { Component } from 'react';
import styles from './BlogPage.module.css';
import firebase from '../helpers/firebase';
import { Helmet } from 'react-helmet';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import Mailchimp from '../helpers/Mailchimp';
import IconButton from '@material-ui/core/IconButton';
import { ReactComponent as Logo } from '../logo.svg';

export default class BlogPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posts: {},
    };
  }

  async componentDidMount(): void {
    const blogCollection = await firebase.firestore().collection('blog').get();
    let posts = {};
    blogCollection.docs.forEach((doc) => {
      posts[doc.id] = doc.data();
    });
    this.setState({ posts: posts });
    console.log(posts);
  }

  render() {
    let url = window.location.href.split('/');
    let articleId = url[url.length - 1].split('?')[0];
    if (articleId === '') {
      articleId = url[url.length - 2];
    }
    console.log(url);
    // let imageUrl = "";
    // let shortText = "";
    let title = '';
    let content = '';
    let date = new Date();

    if (this.state.posts[articleId]) {
      // imageUrl = "https://firebasestorage.googleapis.com/v0/b/dewaste.appspot.com/o/blogImages%2F" + this.state.posts[articleId]["image"] + "?alt=media";
      // shortText = this.state.posts[articleId]["shortText"];
      title = this.state.posts[articleId]['title'];
      content = this.state.posts[articleId]['content'];
      date = this.state.posts[articleId]['date'].toDate();
    }
    return (
      <div>
        <Helmet>
          <style>{'body { background-color: #f8f8f8; }'}</style>
        </Helmet>
        <Helmet>
          <meta
            name="description"
            content="The DeWaste Blog is the place to see content regarding new locations that you’ll find DeWaste at, new products that we launch, and so much more!"
          />

          <meta
            itemProp="name"
            content="DeWaste | Food Waste Analysis for all dining institutions"
          />
          <meta
            itemProp="description"
            content="The DeWaste Blog is the place to see content regarding new locations that you’ll find DeWaste at, new products that we launch, and so much more!"
          />
          <meta itemProp="image" content="https://de-waste.com/logo.png" />

          <meta property="og:image" content="https://de-waste.com/logo.png" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="DeWaste" />
          <meta
            property="og:description"
            content="The DeWaste Blog is the place to see content regarding new locations that you’ll find DeWaste at, new products that we launch, and so much more!"
          />
          <meta property="og:site_name" content="DeWaste" />
          <meta property="og:url" content="https://de-waste.com/blog" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:image" content="https://de-waste.com/logo.png" />
          <meta name="twitter:title" content="DeWaste" />
          <meta
            name="twitter:description"
            content="The DeWaste Blog is the place to see content regarding new locations that you’ll find DeWaste at, new products that we launch, and so much more!"
          />

          <title>DeWaste Blog | The latest news on DeWaste</title>
        </Helmet>

        <div className={styles.sidebar}>
          <a
            href={'https://de-waste.com/blog'}
            style={{ textDecoration: 'none' }}
          >
            <img
              src={'https://de-waste.com/img/logo.png'}
              alt={'DeWaste'}
              className={styles.logo}
            />
            <br />
            <h1 className={styles.mainText}>
              <span style={{ color: '#009432' }}>De</span>
              <span style={{ color: '#000000' }}>Waste Blog</span>
            </h1>
            <br />
          </a>
          <div className={styles.sidebarButtonsDiv}>
            <div className={styles.sidebarSingleButtonDiv}>
              <IconButton
                color="primary"
                href={'https://de-waste.com/'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Logo width={'30px'} height={'30px'} />
              </IconButton>
            </div>

            <div className={styles.sidebarSingleButtonDiv}>
              <IconButton
                color="primary"
                href={'https://www.instagram.com/dewasteofficial/'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </IconButton>
            </div>
            <div className={styles.sidebarSingleButtonDiv}>
              <IconButton
                color="primary"
                href={'https://www.facebook.com/dewasteofficial/'}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FacebookIcon />
              </IconButton>
            </div>
          </div>
        </div>

        <div className={styles.contentBlock}>
          <h1 className={styles.articleTitle}>{title}</h1>
          <br />
          <span
            className={styles.articleContent}
            dangerouslySetInnerHTML={{
              __html:
                date.getMonth() +
                1 +
                '/' +
                date.getDate() +
                '/' +
                date.getFullYear(),
            }}
          />

          <br />
          <br />
          <span
            className={styles.articleContent}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>

        <div className={styles.signUpBlock}>
          <br />
          <span className={styles.signUpText}>
            Be the first to learn about the latest DeWaste news.{' '}
          </span>
          <hr />
          <br />
          <Mailchimp
            action="https://de-waste.us18.list-manage.com/subscribe/post?u=0c467677623daa30d3d670b81&amp;id=b21f4d595f"
            fields={[
              {
                name: 'EMAIL',
                placeholder: 'Email',
                type: 'email',
                required: true,
              },
            ]}
          />
        </div>
      </div>
    );
  }
}
